import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-up-logo-small",
  "use": "ico-up-logo-small-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol viewBox=\"0 0 18 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-up-logo-small\">\n<path d=\"M7.04161 21.7596L4.44001 19.7292L1.32001 3.80641L14.0052 1.32001L16.68 3.40681V14.1564L10.0308 22.68L7.04161 21.7596Z\" stroke=\"white\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol